import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AccessPermissionDirective,
  ActivatedRoutePermissionDirective,
  AdminAccessPermissionDirective,
  DeveloperAccessPermissionDirective,
  EditAccessPermissionDirective,
  EntityEditAccessPermissionDirective,
  ModuleEditAccessPermissionDirective,
} from './access-permission/access-permission.directive';
import { AuthDirective } from './auth/auth.directive';

@NgModule({
  imports: [
    CommonModule,
    AuthDirective,
    AccessPermissionDirective,
    ActivatedRoutePermissionDirective,
    AdminAccessPermissionDirective,
    EditAccessPermissionDirective,
    EntityEditAccessPermissionDirective,
    ModuleEditAccessPermissionDirective,
    DeveloperAccessPermissionDirective,
  ],
  exports: [
    AuthDirective,
    AccessPermissionDirective,
    ActivatedRoutePermissionDirective,
    AdminAccessPermissionDirective,
    EditAccessPermissionDirective,
    EntityEditAccessPermissionDirective,
    ModuleEditAccessPermissionDirective,
    DeveloperAccessPermissionDirective,
  ],
})
export class AccessPermissionsModule {}
